import { useState } from "react";
import { useNotify, useRefresh } from "react-admin";
import { Box, FormHelperText } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import LoadingActionButton from "server/components/LoadingActionButton";
import dataProvider from "server/dataProvider";
import { publicationRequests } from "api/publicationApi";
import { useNotifyError } from "utils/useNotifyError";

// The import is synchronous on the backend, so the list can be refreshed as soon as the request resolves.
// `canImport` comes from the publication profile — the import needs the ORCID and an author name to match by.
const ImportPublicationsButton = ({ canImport, align = "flex-end" }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  const handleImport = async () => {
    setLoading(true);
    try {
      await dataProvider.customRequest(publicationRequests.importPublications(), null, "POST");
      notify("Публикациите са импортирани успешно", { type: "success" });
      refresh();
    } catch (err) {
      notifyError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: align }}>
      <LoadingActionButton
        label="Импортирай публикации"
        icon={<SyncIcon />}
        onClick={handleImport}
        loading={loading}
        disabled={!canImport || loading}
        width="auto"
      />
      <FormHelperText sx={{ mx: 1, mt: 0 }}>
        Необходими са ORCID и поне едно име в публикации
      </FormHelperText>
    </Box>
  );
};

export default ImportPublicationsButton;
